// extracted by mini-css-extract-plugin
module.exports = {"container":"signInContainerStyles_container__1ubRn","noBorder":"signInContainerStyles_noBorder__KDIHp"};